import { ReactElement } from 'react';
import { getClasses } from '@/utils';

export type InvoicePdfDetailListProps = React.ComponentProps<'ul'>;

const InvoicePdfDetailList = ({ ...props }: InvoicePdfDetailListProps): ReactElement => (
  <ul {...props} className={getClasses('InvoicePdf-DetailList', props.className)} />
);

export default InvoicePdfDetailList;
